class LoadMore {
  constructor() {
    this.initialize();
  }
  initialize() {
    this.currentPage = 1;
    this.button = document.querySelector('[data-load-more]');
    if(!this.button) return;
    
    this.list = document.querySelector('.collection__product-grid');
    this.url = this.button.getAttribute('data-url');
    this.pages = parseInt(this.button.getAttribute('data-pages'), 10);
    
    if(this.pages <= 1) {
      this.button.style.display = 'none';
    }
    
    this.button.addEventListener('click', () => {
      this.button.innerHTML = 'Loading...';
      this.currentPage += 1;
      
      // Build the URL with the next page
      let fetchUrl = this.url;
      
      // Check if URL already has a page parameter and replace it
      if(fetchUrl.match(/[?&]page=\d+/)) {
        fetchUrl = fetchUrl.replace(/([?&])page=\d+/, '$1page=' + this.currentPage);
      } else if(fetchUrl.includes('?')) {
        fetchUrl = fetchUrl + '&page=' + this.currentPage;
      } else {
        fetchUrl = fetchUrl + '?page=' + this.currentPage;
      }
      
      fetch(fetchUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'html',
          'X-Requested-With':'xmlhttprequest'
        }
      })
        .then(res => res.text())
        .then(res => {
          const html = new DOMParser().parseFromString(res, 'text/html')
          const items = html.querySelectorAll('.collection__product-grid li');
          items.forEach(item => {
            this.list.appendChild(item);
            scrollEvents.initialize();
          })
          if(productTransition) productTransition.initialize();
          if(lazyImages) lazyImages.initialize();
          this.button.innerHTML = 'Load More';
          if(this.currentPage > this.pages) {
            this.button.style.display = 'none';
          }
        })
        .catch(error => {
          console.error('Load more error:', error);
          this.button.innerHTML = 'Load More';
        })
    })
  }
}
const loadMore = new LoadMore();
